import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

// import './styles.css';

// import required modules
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper/modules";

export default function App() {
  return (
    <>
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
        effect="fade"
        speed={1500}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        navigation={true}
        pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
        className="mySwiper w-[85%] h-fit hidden md:flex"
        autoplay={{
          delay: 3000, // Delay between each slide transition in milliseconds (3 seconds in this example)
          disableOnInteraction: false, // Set to true if you want to stop autoplay on user interaction (e.g., touch)
        }}
      // Other Swiper configuration options
      >
        <SwiperSlide>
          <div className=' flex justify-center items-center flex-wrap gap-[5vw] mt-[15vw] lg:mt-[3vw] h-fit w-full  rounded-lg p-[2vw] overflow-hidden' >
            <div className='w-[95%] lg:w-[35%] lg:h-[18vw] h-[40vw] transition-all duration-[1s]' id='what-image'>
              <img src="https://res.cloudinary.com/dldjt5ca6/image/upload/v1693938357/Roots/ce1375d541177283b86cd541c33e99aa_rthexc.png" alt="" className=' w-full h-full ' />
            </div>
            <div className='w-[95%] lg:w-[45%] flex flex-col text-justify transition-all duration-[1s]' id='what-block'>
              <h2 className=' text-[#595959] shadow-[rgba(217,217,217,0.22)] text-4xl w-fit font-bold'>
                What is Roots ?
                <hr className=' border-2  mb-[1vw] w-3/4' />
              </h2>
              <p className='text-xl lg:tracking-[0.05rem] font-medium  '>
                Roots is the nexus of creativity at NIT Rourkela , where Design, Art, Photography, Film-Making, Music, and Literature converge to reignite inspiration by tracing back to origins. As the university's Creative Confluence, it serves as a vibrant bridge between tradition and innovation, resonating with the rich artistic heritage of NIT Rourkela while propelling creativity into the future.
              </p>
            </div>

          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className=' flex justify-center items-center flex-wrap gap-[5vw] mt-[15vw] lg:mt-[3vw] h-fit w-full  rounded-lg p-[2vw] overflow-hidden' >
            <div className='w-full lg:w-[40%] lg:h-[18vw] h-[40vw] transition-all duration-[1s]' id='when-image'>
              <img src="https://res.cloudinary.com/dldjt5ca6/image/upload/v1693809360/Roots/singger-man-character-abstract-vector-illustration_16787-129_ijsd4h.png" alt="" className='w-full h-full' />
            </div>
            <div className='w-[95%] lg:w-[45%] flex flex-col text-justify transition-all duration-[1s]' id='what-block'>
              <h2 className=' text-[#595959] shadow-[rgba(217,217,217,0.22)] text-4xl w-fit font-bold'>
                When Roots ?
                <hr className=' border-2  mb-[1vw] w-3/4' />
              </h2>
              <p className='text-xl lg:tracking-[0.05rem] font-medium  '>
                We are pleased to announce that the fifth edition of Roots is scheduled to take place from September 8th to 10th.

                The upcoming event will showcase engaging guest lectures, interactive workshops, and informative expert-led exhibitions.
              </p>
            </div>

          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className=' flex justify-center items-center flex-wrap gap-[5vw] mt-[15vw] lg:mt-[3vw] h-fit w-full  rounded-lg p-[2vw] overflow-hidden' >
            <div className='w-[95%] lg:w-[35%] lg:h-full h-[40vw] transition-all duration-[1s]' id='what-image'>
              <img src="https://res.cloudinary.com/dldjt5ca6/image/upload/v1693747368/Roots/persuasive_speech-removebg-preview_j3goyx.png" alt="" className='w-full h-full ' />
            </div>
            <div className='w-[95%] lg:w-[45%] flex flex-col text-justify transition-all duration-[1s]' id='what-block'>
              <h2 className=' text-[#595959] shadow-[rgba(217,217,217,0.22)] text-4xl w-fit font-bold'>
                Why Roots ?
                <hr className=' border-2  mb-[1vw] w-3/4' />
              </h2>
              <p className='text-xl lg:tracking-[0.05rem] font-medium  '>
                Your incredible journey has just started, and we are delighted to have you join us for this special occasion. Your presence at the event will undoubtedly enhance its overall quality, and we eagerly anticipate commemorating your involvement with a truly memorable ceremony.
              </p>
            </div>

          </div>
        </SwiperSlide>
      </Swiper>
    </>
  );
}
